import Select from "./Select.vue";
import Options from "./Options.vue";

export default Select;



// WEBPACK FOOTER //
// ./src/components/rcmTableFormItems/Select/index.js